import React from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Wrapper from "@components/wrapper";
import Row from "@components/row";
import Fields from "@components/fields";
import Button from "@components/button";
import { timeZones, timeFormats, currencySymbols } from "@utils/constants";
import { useGeneralSettings } from "@hooks/useGeneralSettings";
import generalSettings from "@apis/generalSettings";
import { toast } from "react-toastify";

const GeneralSettingsComponent = () => {
  const { settings, existing, setSettings, loading } = useGeneralSettings();
  console.log(existing, "exs");
  if (loading) return <div>Loading...</div>;

  const handleSubmit = async (values: typeof settings) => {
    const payload = {
      key: "general-settings",
      infos: {
        ...values,
        currencySymbol: values.currency, // Legacy support
        currencySymbolCustom: values.currencySymbol, // Actual symbol
      },
    };
    try {
      if (existing?.id) {
        await generalSettings.update({
          state: "generals",
          id: existing.id,
          data: payload,
        });
      } else {
        try {
          await generalSettings.create({
            state: "generals",
            data: payload,
          });
        } catch (err: any) {
          // If creation fails due to existing key, try to find and update
          if (err.message?.includes("already exists")) {
            console.log("Record exists, switching to update...");
            const res = await generalSettings.getByKey({
              state: "generals",
              id: "general-settings",
              showErr: false,
            });
            if (res?.id) {
              await generalSettings.update({
                state: "generals",
                id: res.id,
                data: payload,
              });
            } else {
              throw err;
            }
          } else {
            throw err;
          }
        }
      }
      toast.success("Settings updated successfully");
    } catch (err: any) {
      console.error(err);
      toast.error(err.message || "Something went wrong");
    }
  };

  return (
    <Formik initialValues={settings} enableReinitialize onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="General Settings" />
          <Wrapper>
            <Row>
              <div style={{ flex: 1 }}>
                <Fields.DropDown
                  name="timeZone"
                  label="Time Zone"
                  options={timeZones}
                  titleAsKey="title"
                  valueAsKey="key"
                  hasSearch
                  styleInput="width:97%"
                  placeholder="---select time zone---"
                />
              </div>
              <div style={{ flex: 1 }}>
                <Fields.DropDown
                  name="timeFormat"
                  label="Time Format"
                  options={timeFormats}
                  titleAsKey="title"
                  valueAsKey="key"
                  styleInput="width:97%"
                  placeholder="---selec time format---"
                />
              </div>
              <div style={{ flex: 1 }}>
                <Fields.DropDown
                  name="currency"
                  label="Currency"
                  options={currencySymbols}
                  titleAsKey="title"
                  valueAsKey="key"
                  hasSearch
                  styleInput="width:97%"
                  placeholder="---select currency---"
                  onChange={(value) => {
                    setFieldValue("currency", value);
                    const selectedOption = currencySymbols.find(
                      (c) => c.key === value,
                    );
                    if (selectedOption) {
                      const match = selectedOption.title.match(/\(([^)]+)\)$/);
                      if (match) {
                        setFieldValue("currencySymbol", match[1]);
                      }
                    }
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Fields.Input
                  name="currencySymbol"
                  label="Currency Symbol"
                  placeholder="Ex: $"
                  styleInput="width:97%"
                />
              </div>
            </Row>
            <br />
            <Row>
              <div style={{ flex: 1 }}>
                <Fields.DropDown
                  name="currencyPosition"
                  label="Currency Position"
                  options={[
                    { key: "left", title: "Left" },
                    { key: "right", title: "Right" },
                  ]}
                  titleAsKey="title"
                  valueAsKey="key"
                  styleInput="width:97%"
                  placeholder="---select currency position---"
                />
              </div>

              <div style={{ flex: 1 }}>
                <Fields.Switch name="isDecimal" label="Is Decimal?" />
                {values.isDecimal && (
                  <Fields.Input
                    name="decimalPlaces"
                    label="Decimal Places"
                    type="number"
                    placeholder="Ex: 2"
                    styleInput="width:97%"
                  />
                )}
              </div>
            </Row>
            <br />
            <Row>
              <div style={{ flex: 1 }}>
                <Fields.Input
                  name="topTitle"
                  label="Top Title"
                  placeholder="Ex: My Top Title"
                  styleInput="width:97%"
                />
              </div>
              <div style={{ flex: 1 }}>
                <Fields.Input
                  name="middleTitle"
                  label="Middle Title"
                  placeholder="Ex: My Middle Title"
                  styleInput="width:97%"
                />
              </div>
              <div style={{ flex: 1 }}>
                <Fields.Input
                  name="bottomTitle"
                  label="Bottom Title"
                  placeholder="Ex: My Bottom Title"
                  styleInput="width:97%"
                />
              </div>
            </Row>
            <br />
            <Button
              type="submit"
              title={existing ? "Update" : "Save"}
              justify="end"
            />
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default GeneralSettingsComponent;
